import React from 'react'
import './btnStyle.css'
import {CSVLink} from "react-csv";
import {Tooltip} from "antd";
import {Button} from 'semantic-ui-react'
import cloneDeep from 'lodash/cloneDeep';

class App extends React.Component {
  render() {
    let data = cloneDeep(this.props.data);
    if (this.props.userType === "VISITOR" || this.props.userType === "VISITOR_HISTORY" || this.props.userType === "VISITOR_CHECKIN" || this.props.userType === "VISITOR_OVERDUE" || this.props.userType === "MEETING_VISITORS") {
      if (data.length !== 0) {
        data.map((element, index) => {
          if (!element.meetingVisitorId.toString().startsWith("V")) {
            element.meetingVisitorId = "V" + element.meetingVisitorId
          }
        })
      }
    } else if (this.props.userType === "MEETING" || this.props.userType === "MEETING_ALL_REPORT") {
      if (data.length !== 0) {
        data.map((element, index) => {
          if (!element.meetingId.toString().startsWith("M")) {
            element.meetingId = "M" + element.meetingId
          }
        })
      }
    } else if (this.props.userType === "QR_CHECK_IN_BRANCH") {
      if (data.length !== 0) {
        data.map((element, index) => {
          element.meetingVisitorId = element.meetingVisitorId.toString().startsWith("V") ? element.meetingVisitorId : "V" + element.meetingVisitorId;
          delete element.covidQuestionResponses;
          delete element.isCovidForm
        })
      }
    } else if (this.props.userType === "RMV_BUILDING") {
      if (data.length !== 0) {
        data.map((element, index) => {
          delete element.buildings
        })
      }
    } else if (this.props.userType === "MANAGE_BUILDINGS") {
      if (data.length !== 0) {
        data.map((element, index) => {
          // element.floors = element.floors.length;
          delete element.floors
        })
      }
    }

    return (
      <div>
        {
          this.props.data.length !== 0 ?
            <CSVLink data={data} filename={this.props.filename === undefined ? "tags-report.csv" : this.props.filename}>
              <Tooltip placement="topLeft" title="Download CSV file">
                <Button.Group className={this.props.right ? "download-btn-right" : "download-btn"} basic size='small'>
                  <Button icon='download'/>
                </Button.Group>
              </Tooltip>
            </CSVLink>
            : null
        }
      </div>

    );
  }
}

export default App;
